// @ts-nocheck
import React from 'react';
import Button from '../../common/Button';
import icons from '../../../constants/icons';
import KebabMenu from '../../common/KebabMenu';
import { canCopyRequest } from '../../../util/permissions';
import { useTranslation } from 'react-i18next';

export interface RequestGroupListButtonsProps {
  row: any;
  handleCopyRequest?: (e: any, row: any) => void;
  currentUser: any;
}

function RequestGroupListButtons({
  row,
  handleCopyRequest,
  currentUser,
}: RequestGroupListButtonsProps) {
  const { t } = useTranslation();
  return (
    <>
      <KebabMenu
        take={1}
        className="inline-icons"
        buttons={[
          typeof handleCopyRequest === 'function' && (
            <Button
              isDisabled={
                !canCopyRequest({
                  companyId: row.companyId,
                  requestedById: row.requestedById,
                  currentUser,
                })
              }
              className="btn btn-default me-2"
              onClick={(e) => handleCopyRequest(e, row)}
              icon={icons.REQUEST_AGAIN}
              text={t('Request again')}
              title={t('Make a new request based on this request')}
            ></Button>
          ),
        ]}
      ></KebabMenu>
    </>
  );
}

export default RequestGroupListButtons;
